export default __webpack_public_path__ + "static/media/Classwin_certificateQRcode.5c3ce8fa.png";